import { useEffect, useMemo } from "react";
import useRedux from "./useRedux";
import { loadAccts } from "../domain/accts/acctsActions";
import groupAccounts from "../components/containers/secure/Dashboard/groupAccounts";
export default function useAccounts() {
    const [props, dispatch] = useRedux(state => ({
        accts: state.accts.data,
        error: state.accts.error,
        loading: state.accts.isLoading,
        locale: state.i18n.locale,
        loggedIn: state.auth.loggedIn
    }));
    const { error, locale } = props;
    const loading = props.loading || (props.accts == null && error == null);
    const accts = useMemo(() => (groupAccounts(props.accts || [], locale)), [props.accts, locale]);
    useEffect(() => {
        if (props.loggedIn
            && !props.loading
            && props.accts == null
            && error == null) {
            dispatch(loadAccts());
        }
    });
    return {
        loading,
        error,
        accts
    };
}



// WEBPACK FOOTER //
// ./src/assets/scripts/hooks/useAccounts.ts